/***
 * Author：zyk
 * Date：2022-12-22 10:47:32
 * Description: 前端短信防刷 接入腾讯滑动验证码
 * Copyright © 2020 找我婚礼. All rights reserved.
 **/
import env from "../config/api";
const errorMsg = {
  1001: "TCaptcha.js 加载错误",
  1002: "调用 show 方法超时",
  1003: "中间 js 加载超时",
  1004: "中间 js 加载错误",
  1005: "中间 js 运行错误",
  1006: "拉取验证码配置错误/超时",
  1007: "iframe 加载超时",
  1008: "iframe 加载错误",
  1009: "jquery 加载错误",
  1010: "滑块 js 加载错误",
  1011: "滑块 js 运行错误",
  1012: "刷新连续错误3次",
  1013: "验证网络连续错误3次",
};

/**
 * 防刷暴露方法
 * @param next callback 回调方法，防刷校验成功或不需要防刷校验时 继续你的验证码逻辑
 */
export const verificationCode = (next, vm) => {
  // 生成一个滑块验证码对象
  let captchaId = env.APP_TENCENT_APPID.toString(); // 腾讯滑块验证码appid
  var captcha = new TencentCaptcha(
    captchaId,
    function callback(res) {
      // 验证成功时触发回调函数，继续主线逻辑
      const { randstr, ticket, errorCode } = res;
      if (Number(errorCode) > 0) {
        vm.$message.error(errorMsg[errorCode]);
        return;
      }
      if (res.ret == 0) next(randstr, ticket);
    },
    {}
  );
  captcha.langFun();
  // 滑块显示
  captcha.show();
};

// 初始化方法 引入js文件
const init = () => {
  if (isInclude("TCaptcha.js")) return;
  let script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://turing.captcha.qcloud.com/TCaptcha.js";
  document.body.appendChild(script);
};
// 判断当前js是否已经引入，防止重复引入报错
const isInclude = (name) => {
  var js = /js$/i.test(name); //正则表达式查找页面是否有js
  var es = document.getElementsByTagName(js ? "script" : "link"); //如果有js，页面查找script
  for (var i = 0; i < es.length; i++) {
    if (es[i][js ? "src" : "href"].indexOf(name) != -1) return true;
  }
  return false;
};

init();



// WEBPACK FOOTER //
// ./src/plugin/verificationCode.js